module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "toc"
    }
  }, [_c('h1', {
    attrs: {
      "id": "toc-title"
    }
  }, [_vm._v("Memoirs of the Village Idiot")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch001#about-the-author"
    }
  }, [_vm._v("About the Author")])]), _c('li', {
    attrs: {
      "id": "toc-li-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch002#dedication"
    }
  }, [_vm._v("Dedication")])]), _c('li', {
    attrs: {
      "id": "toc-li-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch003#copyright-information"
    }
  }, [_vm._v("Copyright Information ©")])]), _c('li', {
    attrs: {
      "id": "toc-li-4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch004#acknowledgement"
    }
  }, [_vm._v("Acknowledgement")])]), _c('li', {
    attrs: {
      "id": "toc-li-5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#foreword"
    }
  }, [_vm._v("Foreword")])]), _c('li', {
    attrs: {
      "id": "toc-li-6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch006#the-vacuum-war"
    }
  }, [_vm._v("The Vacuum War")])]), _c('li', {
    attrs: {
      "id": "toc-li-7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch007#one-too-many",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("One Too Many")])]), _c('li', {
    attrs: {
      "id": "toc-li-8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch008#the-blank-chapter",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Blank Chapter")])]), _c('li', {
    attrs: {
      "id": "toc-li-9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch009#black-blood",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Black Blood")])]), _c('li', {
    attrs: {
      "id": "toc-li-10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch010#the-never-watchful-eye",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Never-Watchful Eye")])]), _c('li', {
    attrs: {
      "id": "toc-li-11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#the-good",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Good")])]), _c('li', {
    attrs: {
      "id": "toc-li-12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#far-from-home",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Far from Home")])]), _c('li', {
    attrs: {
      "id": "toc-li-13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch013#the-bitter-victory",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Bitter Victory")])]), _c('li', {
    attrs: {
      "id": "toc-li-14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch014#lost-chance",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lost Chance?")])]), _c('li', {
    attrs: {
      "id": "toc-li-15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#the-lyrical-urge",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Lyrical Urge")])]), _c('li', {
    attrs: {
      "id": "toc-li-16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch016#words-of-life",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Words of Life")])]), _c('li', {
    attrs: {
      "id": "toc-li-17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch017#borrowed-time",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Borrowed Time")])]), _c('li', {
    attrs: {
      "id": "toc-li-18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch018#freedomfreedom",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Freedom/Freedom")])]), _c('li', {
    attrs: {
      "id": "toc-li-19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch019#my-own",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("My Own")])]), _c('li', {
    attrs: {
      "id": "toc-li-20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch020#troubled-soul",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Troubled Soul")])]), _c('li', {
    attrs: {
      "id": "toc-li-21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch021#the-betrayal",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Betrayal")])]), _c('li', {
    attrs: {
      "id": "toc-li-22"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch022#of-rivers-and-sand",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Of Rivers and Sand")])]), _c('li', {
    attrs: {
      "id": "toc-li-23"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch023#déjà-vu",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Déjà Vu")])]), _c('li', {
    attrs: {
      "id": "toc-li-24"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch024#the-breaking-point",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Breaking Point")])]), _c('li', {
    attrs: {
      "id": "toc-li-25"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch025#memories-of-a-timeless-past",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Memories of a Timeless Past")])]), _c('li', {
    attrs: {
      "id": "toc-li-26"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch026#the-phantom-lover",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Phantom Lover")])]), _c('li', {
    attrs: {
      "id": "toc-li-27"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch027#i-flourish",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I Flourish")])]), _c('li', {
    attrs: {
      "id": "toc-li-28"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch028#what-then",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("What Then?")])]), _c('li', {
    attrs: {
      "id": "toc-li-29"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch029#the-villager-vents",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Villager Vents")])]), _c('li', {
    attrs: {
      "id": "toc-li-30"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch030#i-digress",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I Digress")])]), _c('li', {
    attrs: {
      "id": "toc-li-31"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch031#things-fall-to-pieces",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Things Fall to Pieces")])]), _c('li', {
    attrs: {
      "id": "toc-li-32"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch032#death-as-i-know-it",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Death as I Know It")])]), _c('li', {
    attrs: {
      "id": "toc-li-33"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch033#paths-to-nowhere",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Paths to Nowhere")])]), _c('li', {
    attrs: {
      "id": "toc-li-34"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch034#living-outside-the-purpose",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Living Outside ‘The Purpose’")])]), _c('li', {
    attrs: {
      "id": "toc-li-35"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch035#we-plan-and-god-laughs",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("We Plan and God Laughs")])]), _c('li', {
    attrs: {
      "id": "toc-li-36"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch036#the-village",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Village")])]), _c('li', {
    attrs: {
      "id": "toc-li-37"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch037#fighting-against-the-universe",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fighting Against the Universe")])]), _c('li', {
    attrs: {
      "id": "toc-li-38"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch038#sleep-terror",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sleep Terror")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41e49fa1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nav.vue
// module id = 60
// module chunks = 0